import { logger } from './logger';

export class AppError extends Error {
  constructor(
    message: string,
    public code: string,
    public userMessage: string,
    public metadata?: Record<string, unknown>
  ) {
    super(message);
    this.name = 'AppError';
  }
}

export const errorMessages = {
  // Authentication errors
  AUTH_INVALID_CREDENTIALS: 'Invalid email or password',
  AUTH_EMAIL_NOT_CONFIRMED: 'Please check your email and confirm your account',
  AUTH_WEAK_PASSWORD: 'Password must be at least 8 characters with letters, numbers, and symbols',
  
  // File processing errors
  FILE_TOO_LARGE: 'File size exceeds the maximum limit (50MB)',
  FILE_INVALID_FORMAT: 'Invalid file format. Please upload WAV, MP3, or AIFF files',
  FILE_PROCESSING_FAILED: 'Failed to process audio file. Please try again',
  
  // API errors
  API_NETWORK_ERROR: 'Network error. Please check your connection',
  API_SERVER_ERROR: 'Server error. Please try again later',
  API_RATE_LIMIT: 'Too many requests. Please wait a moment and try again',
  
  // Subscription errors
  SUB_PAYMENT_FAILED: 'Payment failed. Please check your payment details',
  SUB_LIMIT_REACHED: 'You have reached your subscription limit',
  
  // Generic errors
  UNKNOWN_ERROR: 'An unexpected error occurred. Please try again'
};

export const handleError = (error: unknown) => {
  if (error instanceof AppError) {
    logger.error(error.message, {
      code: error.code,
      metadata: error.metadata
    });
    return error.userMessage;
  }

  if (error instanceof Error) {
    logger.error(error.message, {
      stack: error.stack
    });
    return errorMessages.UNKNOWN_ERROR;
  }

  logger.error('Unknown error', { error });
  return errorMessages.UNKNOWN_ERROR;
};